import type {
  Item,
  KeyRow,
  PayloadSetFlags,
  ProjectMetadata
} from "./useSelection.types"

export const SELECT_ROW = "SELECT_ROW" as const

export const onSelectRow = (
  parentRowId: KeyRow,
  nestedRowId: KeyRow,
  selected: boolean
) => ({
  parentRowId,
  nestedRowId,
  selected,
  type: SELECT_ROW
})

export const SELECT_ROWS_NESTED_TABLE = "SELECT_ROWS_NESTED_TABLE" as const

export const onSelectRowsInNestedTable = (
  parentRowId: KeyRow,
  nestedRowIds: KeyRow[]
) => ({
  parentRowId,
  nestedRowIds,
  type: SELECT_ROWS_NESTED_TABLE
})

export const SELECT_ALL_ROWS_NESTED_TABLE =
  "SELECT_ALL_ROWS_NESTED_TABLE" as const

export const onSelectAllRowsInNestedTable = (
  parentRowId: KeyRow,
  selected: boolean
) => ({
  selected,
  parentRowId,
  type: SELECT_ALL_ROWS_NESTED_TABLE
})

export const DISABLED_PARENT_ROW_SELECTION =
  "DISABLED_PARENT_ROW_SELECTION" as const

export const disabledParentRowForSelection = (parentRowId: KeyRow) => ({
  parentRowId,
  type: DISABLED_PARENT_ROW_SELECTION
})

export const SET_IDS_NESTED_TABLE = "SET_IDS_NESTED_TABLE" as const

export const setIdsNestedTable = <I extends Item>(
  items: I[],
  parentRowId: KeyRow,
  metadata: ProjectMetadata
) => ({
  items,
  parentRowId,
  metadata,
  type: SET_IDS_NESTED_TABLE
})

export const EXPANDED_PARENT_ROW = "EXPANDED_PARENT_ROW" as const

export const expandedParentRow = (parentRowId: KeyRow, expanded?: boolean) => ({
  parentRowId,
  expanded,
  type: EXPANDED_PARENT_ROW
})

export const SET_UPDATING_STATE_FOR_PARENT_ROWS =
  "SET_UPDATING_STATE_FOR_PARENT_ROWS" as const

export const setUpdatingStateForParentRow = (
  updating: boolean,
  parentRowIds: KeyRow[],
  withErrorRowIds?: KeyRow[]
) => ({
  type: SET_UPDATING_STATE_FOR_PARENT_ROWS,
  updating,
  parentRowIds,
  withErrorRowIds
})

export const SET_FLAGS_STATE = "SET_FLAGS_STATE" as const

export const setFlags = (payload: PayloadSetFlags = {}) => ({
  type: SET_FLAGS_STATE,
  payload
})

export const UNSELECT_ALL = "UNSELECT_ALL" as const

export const unselectAll = () => ({
  type: UNSELECT_ALL
})

export const SELECT_ALL = "SELECT_ALL" as const

export const selectAll = (payload?: boolean) => ({
  type: SELECT_ALL,
  payload
})

export const SET_UPDATING_ALL = "SET_UPDATING_ALL" as const

export const setUpdatingAll = (updating: boolean) => ({
  type: SET_UPDATING_ALL,
  payload: updating
})

export const SELECT_ALL_ALLOCATABLE_ISSUES =
  "SELECT_ALL_ALLOCATABLE_ISSUES" as const

export const selectAllAllocatableIssues = () => ({
  type: SELECT_ALL_ALLOCATABLE_ISSUES
})

export const UNSELECT_ROW = "UNSELECT_ROW" as const

export const unselectRow = (
  id: KeyRow,
  selected: boolean,
  parentRowId?: KeyRow
) => ({
  id,
  selected,
  parentRowId,
  type: UNSELECT_ROW
})
